import { Box, Tooltip } from '@mui/material';
import { Tag, Typography, colors } from '@sweep-io/sweep-design';
import { ComponentType, ReactNode } from 'react';
import { DataTableVariant } from '../../common/table/TableTypes';
import { dataTableVariants } from '../../common/table/dataTableVariants';
import { useOptimizedTextClamping } from '../hooks/useOptimizedTextClamping';

export const FieldLabelWithNameInTooltip = ({
  name,
  label,
  isRollup,
  fontColor,
  LabelWrapperComponent,
  labelWrapperComponentProps,
}: {
  name: string;
  label: string;
  isRollup?: boolean;
  fontColor?: string;
  LabelWrapperComponent?: ComponentType<{ label: string | ReactNode; rowIndex?: number }>;
  labelWrapperComponentProps?: { rowIndex?: number };
}) => {
  const { ref, isClamped } = useOptimizedTextClamping({
    debounceMs: 50,
  });

  const tooltip = isClamped ? `${label} (${name})` : name;

  return (
    <Box id={name} sx={{ overflow: 'hidden' }}>
      <Tooltip placement="bottom-start" title={tooltip}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            //TODO add support in design system SWEEP-4335
            '& .MuiTypography-root': {
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              whiteSpace: 'break-spaces',
              wordBreak: 'break-word',
            },
          }}
          ref={ref}
        >
          <Typography
            ellipsis={isClamped}
            variant={dataTableVariants[DataTableVariant.medium].fontVariant}
            color={fontColor ?? dataTableVariants[DataTableVariant.small].fontColor}
          >
            {LabelWrapperComponent ? (
              <LabelWrapperComponent
                label={label}
                rowIndex={labelWrapperComponentProps?.rowIndex}
              />
            ) : (
              label
            )}
          </Typography>
          {isRollup && <Tag label="Rollup" color={colors.blue[100]} />}
        </Box>
      </Tooltip>
    </Box>
  );
};
